import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useEffect } from "react";

import { getStripeCheckoutSession } from "api/stripe";
import PaperWrapper from "components/shared/PaperWrapper";
import TabPanel from "components/shared/Tabs/TabPanel";
import ProfileHeader from "components/shared/ProfileHeader";
import BillingPlan from "components/shared/BillingPlan";
import { useCheckoutQueryParams } from "hooks/billingHooks";
import { addCustomerIdToUser } from "api/firebase/stripe";
import { User as FirebaseUser, getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { TabPanelProps } from "types";
import { useUser } from "hooks/users";

interface PaymentSettingsTabProps extends TabPanelProps {
  user?: FirebaseUser | null;
}

export default function PaymentSettingsTab() {
  const [currentUser, loading] = useAuthState(getAuth());
  const { isCheckoutSuccess, sessionId } = useCheckoutQueryParams();

  const user = useUser();

  useEffect(() => {
    if (isCheckoutSuccess && !loading) handleCheckoutSuccess(sessionId);
  }, [isCheckoutSuccess, loading]);

  const handleCheckoutSuccess = async (sessionId: string | null) => {
    enqueueSnackbar("Payment was successful!", { variant: "success" });
    const checkOutSession = await getStripeCheckoutSession({ sessionId });
    addCustomerIdToUser(checkOutSession.customer, currentUser);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Container>
        <ProfileHeader user={user} />
        <PaperWrapper>
          <BillingPlan user={currentUser} />
        </PaperWrapper>
      </Container>
    </Box>
  );
}

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: ".5rem",
});
